


























































































































import { Component } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import { AppModule } from '@/store/Auth/AppModule';
import PageNames from '@/router/PageNames';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductType from '@/models/Products/ProductType';
import ProductSubType from '@/models/Products/ProductSubType';
import GeneralProductSettingsEdit from '@/components/Products/Forms/Shared/GeneralProductSettingsEdit.vue';
import LendingBankSettingsEdit from '@/components/Products/Forms/Lending/LendingBankSettingsEdit.vue';
import LendingInterestSettingsEdit from '@/components/Products/Forms/Lending/LendingInterestSettingsEdit.vue';
import LendingScheduleSettingsEdit from '@/components/Products/Forms/Lending/LendingScheduleSettingsEdit.vue';
import LendingTermSettingsEdit from '@/components/Products/Forms/Lending/LendingTermSettingsEdit.vue';

@Component({ name: 'LendingFixedTermWizard', components: {
    Alert,
    GeneralProductSettingsEdit,
    LendingBankSettingsEdit,
    LendingInterestSettingsEdit,
    LendingScheduleSettingsEdit,
    LendingTermSettingsEdit
} })
export default class extends SaascadaVue {

    currentStep: number = 1;
    ProductSubType = ProductSubType;

    get nextButtonName() {
        return (this.currentStep === 5) ? this.$t('pageText.productWizard.buttons.create') : this.$t('pageText.productWizard.buttons.next');
    }

    get step() {
        return this.currentStep;
    }

    set step(value) {
        if (this.currentStep != value) {
            this.currentStep = value;
        }
    }

    get productId() {
        return ProductWizardModule.createProductViewModel.newProductId;
    }

    get errorMessage(){
        return AppModule.lastError == null? "" : AppModule.lastError.message;
    }

    async navigateToProduct() {
        this.$router.push({ name: PageNames.Product, params: { id: ProductWizardModule.createProductViewModel.newProductId } });
    }

    async refreshPage() {
        this.$router.go(0);
    }

    async backClick() {
        this.step -= 1
    }

    async nextClick() {
        switch (this.currentStep) {
            case 1: {
                if (!(this.$refs.productGeneralDetailsEdit as any).validateForm()) {
                    return;
                }
                this.step += 1;
                break;
            }
            case 2: {
                if (!(this.$refs.lendingBankSettingsEdit as any).validateForm()) {
                    return;
                }
                this.step += 1;
                break;
            }
            case 3: {
                if (!(this.$refs.lendingInterestSettingsEdit as any).validateForm()) {
                    return;
                }
                this.step += 1;
                break;
            }
            case 4: {
                if (!(this.$refs.lendingScheduleSettingsEdit as any).validateForm()) {
                    return;
                }
                this.step += 1;
                break;
            }
            case 5: {
                if (!(this.$refs.lendingTermSettingsEdit as any).validateForm()) {
                    return;
                }
                this.step += 1;
                await this.createProduct();
                break;
            }
        }
    }

    async createProduct() {
        // Set the type and sub type on the view model then create the product
        this.productVM.generalSettings.type = ProductType.Lending;
        this.productVM.generalSettings.subType = ProductSubType.LendingFixedTerm;
        await ProductWizardModule.createProduct();
    }

    get loading() {
        return ProductWizardModule.loadingWizard;
    }

    get productVM() {
        return ProductWizardModule.createProductViewModel;
    }

}
